import _ from 'lodash';
import axios, { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';
import { getBrowser } from 'utils/Platform';
import qs from 'qs';

const staticDefaultParams = {
  format: 'json',
  device_id: 'web',
  device_category: 'web',
  device_model: 'web',
  device_type: 'web',
  device_so: getBrowser(),
  device_manufacturer: 'generic',
  tenant_code: 'clarovideo',
};

export const updateDefaults = (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  // invariant
  _.merge(instance.defaults, properties);
  return instance;
};

const configPost = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
};

const middleware = axios.create();

const getSession = params =>
  middleware.post('middleware/user/isLoggedIn?version=1.0.0', qs.stringify(params));

const getPlaylists = () => middleware.get('middleware/cms/level?version=1.0.0');

const getRibbon = (params = {}) =>
  middleware
    .get('middleware/cms/ribbon', { params })
    .then(({ data }) => data)
    .catch(({ response }) => ({
      ...response.data.errors,
      status: response.status,
    }));

const getPlaylist = params =>
  middleware.get('middleware/cms/playlistDetail?version=1.0.0', { params });


const getPlayerPlaylist = params =>
  middleware.get('middleware/player/player?version=1.0.0', { params });

const getPlayerMedia = params => {
  const source = CancelToken.source();
  const request = middleware.post(
    'middleware/player/playerGetMedia?version=1.0.1',
    qs.stringify(params),
    { cancelToken: source.token },
  );
  request[CANCEL] = () => source.cancel();
  return request;
};

export const postTrackingTime = (url, params, trackParams) =>{
  let getParams = `track=${trackParams.track}&`;
  if (url.includes('track') && url.includes('playlist')) {
    getParams = '&';
  }
  const urlTrack = `${url}${getParams}list_id=${
    trackParams.list_id
  }&version=1.0.0`;
  middleware.post(urlTrack, qs.stringify(params), { ...configPost });
}

export const getTrackingTick = (url, trackParams) =>{
  let getParams = `playlist=${trackParams.playlist}&track=${trackParams.track}`;
  if (url.includes('track') && url.includes('playlist')) {
    getParams = '';
  }
  const urlTrack = `${url}${getParams}&version=1.0.0`;
  middleware.get(urlTrack);
}

export const getTrackingError = url => middleware.get(url);

/**
 * Fixtures
 */
// const getPlayerPlaylist = (params = {}, isBadRequest = false) => {
//   const mock = {
//     status: 200,
//     data: isBadRequest
//       ? require('./fixtures/player-bad.json')
//       : require('./fixtures/player.json'),
//   };

//   return Promise.resolve(mock);
// };

// const getPlayerMedia = (params = {}, isBadRequest = false) => {
//   const mock = {
//     status: 200,
//     data: isBadRequest
//       ? require('./fixtures/media-bad.json')
//       : require('./fixtures/media.json'),
//   };

//   return Promise.resolve(mock);
// };

export {
  staticDefaultParams,
  getSession,
  getPlaylists,
  getPlaylist,
  getPlayerPlaylist,
  getPlayerMedia,
  getRibbon,
};
export default middleware;
